<template>
  <div class="container">
    <step-pic :step="step" :text="text" :picStr="imgSrc"></step-pic>
    <div class="btn-group" v-if="fromPage !== 'Setting'">
      <button class="btn-block btn" @click="pre()">上一步</button>
      <button class="btn-block btn" @click="addEquipment()">二维码扫描</button>
    </div>
    <div class="btn-group" v-else>
      <button class="btn-block btn" @click="pre()">上一步</button>
      <button class="btn-block btn" @click="changeWifi()">更改Wi-Fi</button>
    </div>
  </div>
</template>
<script>
import StepPic from '../../components/StepPic/StepPic.vue'
import axios from 'axios'
import wx from 'weixin-js-sdk'
import Common from '../../assets/js/common.js'
var api = process.env.BASE_URL
var _local = window.location.href
var isLocal = Common.getEvn()
export default {
  components: {
    StepPic
  },
  data () {
    return {
      fromPage: this.$route.query.pageName,
      deviceIdEx: this.$route.query.deviceIdEx,
      step: '步骤二',
      text: '请打开手机扫描，与设备建立联系',
      imgSrc: Common.staticHref() + 'img/stepTwo.jpg',
      userId: localStorage.getItem('max_userId')
    }
  },
  methods: {
    addEquipment () {
      this.scanCode(this)
    },
    pre () {
      this.$router.back(-1)
    },
    verify () {
      var _this = this
      window.popstate = function () {
        _this.cancelBack()
        if (_this.fromPage === 'Main') {
          let href = ''
          if (_local.indexOf('device_id_ex') > -1) {
            href = _local.split('?')[0]
          }
          window.location.replace(href)
        }
      }
      window.addEventListener('popstate', window.popstate, false)
    },
    cancelBack () {
      window.removeEventListener('popstate', window.popstate)
    },
    changeWifi () {
      this.configWifi(this)
    },
    configWifi (_this) {
      wx.invoke('configWXDeviceWiFi', {}, function (res) {
        console.log(res)
        var errMsg = res.err_msg
        if (errMsg === 'configWXDeviceWiFi:ok') {
          // 配置成功
          // alert('WIFI配置成功')
          // 配网成功之后的回调地址
          _this.$router.push({path: '/wifiSuccess', query: {pageName: _this.fromPage}})
        } else if (errMsg === 'configWXDeviceWiFi:fail') {}
      })
    },
    // 绑定设备
    bundle (url) {
      if (this.deviceIdEx === '%C3%BF%C3%BF%C3%BF%C3%BF%C3%BF%C3%BF%C3%BF%C3%BF%C3%BF%C3%BF%C3%BF%C3%BF') {
            // console.log('deviceId>>>' + this.deviceIdEx)
        this.toast = this.$createToast({
          txt: '设备ID错误 请检测设备电量',
          type: 'txt'
        }).show()
        return false
      }
      var _url = url || _local
      // http://app.hwlantian.com?deviceId=E3-480034000b514d4e30363820&hardware=E3%201.0.0%20alpha&firmware=E3%201.0.1%20alpha
      // 'http://www.miaomiaoce.com/mydevice/max/test/index.html?device_id_ex=d8f15b02246e'
      var preUrl = _url.split('?')[0]
      var preUrl1 = _url.split('?')[1].split('=')[1]
      if (preUrl1 === 'ÿÿÿÿÿÿÿÿÿÿÿÿ') {
        this.toast = this.$createToast({
          txt: '设备ID错误 请检测设备电量',
          type: 'txt'
        }).show()
        return false
      }
      if (isLocal === 'prod') {
        if (preUrl.indexOf('test') > -1) {
          this.toast = this.$createToast({
            txt: '该设备目前在测试模式',
            type: 'txt'
          }).show()
          return false
        }
      } else if (isLocal === 'test') {
        if (preUrl.indexOf('prod') > -1) {
          this.toast = this.$createToast({
            txt: '请在秒秒测公众号上绑定设备',
            type: 'txt'
          }).show()
          return false
        }
      }
      let deviceId = this.deviceIdEx ? this.deviceIdEx : _url.split('?')[1].split('=')[1].split('&')[0]
      this.deviceIdEx = deviceId
      this.fromPage = 'Main'
      this.toast = this.$createToast({
        time: 0,
        txt: '正在绑定设备',
        mask: true
      }).show()
      if (isLocal === 'local') {
        axios.post('/Calendar/api/device/device/Bundle/', {
          'device_id_ex': deviceId,
          'user_id': this.userId
        })
          .then(this.bundleSucess)
          .catch(this.bundleError)
      } else {
        axios.post(api + '/Calendar/api/device/device/Bundle/', {
          'device_id_ex': deviceId,
          'user_id': this.userId
        })
          .then(this.bundleSucess)
          .catch(this.bundleError)
      }
    },
    bundleSucess (res) {
      this.toast.hide()
      let _res = res.data
      let result = _res.result
      if (result === 0) {
        localStorage.setItem('max_device_id', _res.device_id)
        this.$router.push({path: '/ScanSuccess', query: {pageName: this.fromPage}})
      } else if (result === 4) {
        console.log('deviceId>>>++++' + this.deviceIdEx)
        // let deviceId = this.deviceIdEx ? this.deviceIdEx : _url.split('?')[1].split('=')[1].split('&')[0]
        //   if (this.deviceIdEx === "%C3%BF%C3%BF%C3%BF%C3%BF%C3%BF%C3%BF%C3%BF%C3%BF%C3%BF%C3%BF%C3%BF%C3%BF") {
        //     // console.log('deviceId>>>' + this.deviceIdEx)
        //     this.toast = this.$createToast({
        //       txt: '设备ID错误 请检测设备电量',
        //       type: 'txt'
        //     }).show()
        //     return false
        //   }
        // else {
        this.$router.push({path: '/ScanFail2', query: {pageName: this.fromPage, userId: this.userId, deviceIdEx: this.deviceIdEx, result}})
        // eslint-disable-next-line brace-style
      }
      // }
      else if (result === 2) {
        this.$router.push({path: '/ScanFail', query: {pageName: this.fromPage, result}})
      }
    },
    bundleError () {
      this.toast = this.$createToast({
        txt: '调用接口出错！绑定设备失败',
        type: 'txt'
      })
      this.toast.show()
      setTimeout(() => {
        window.location.replace(_local.split('?')[0])
      }, 1000)
    },
    // 页面点击扫码
    scanCode (_this) {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          setTimeout(function () {
            // alert('result:' + res.resultStr)
            var result
            if (res.resultStr.indexOf('device_id_ex') > -1) {
              result = res.resultStr// 当needResult 为 1 时，扫码返回的结果
              // result = 'http://www.miaomiaoce.com/mydevice/max/test/index.html?device_id_ex=d8f15b02246e'
              // alert(result+111)
              _this.bundle(result)
            } else {
               // alert(res.resultStr+2222)
              _this.toast = _this.$createToast({
                txt: '无效的二维码',
                type: 'txt'
              }).show()
            }
          }, 600)
        },
        fail: function () {
          // alert('出错了')
        }
      })
    }
  },
  mounted () {
    Common.setTitle('步骤二')
    if (this.fromPage === 'Main') {
      this.verify()
      this.bundle()
    }
    this.fromPage === 'Setting' ? this.text = '请确认您已进入设备配网模式，请注意：手机需要接入2.4GWi-Fi' : this.text = '请打开手机扫描，与设备建立联系'
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'
.container
  background #ffffff;
  .btn-group
    position absolute;
    bottom 3.3vh;
    width calc(100% - 30px);
    left 15px;
    rowSpaceBetween();
    .btn
      width 48%;
</style>



// WEBPACK FOOTER //
// src/pages/StepTwo/StepTwo.vue